import { z } from 'zod';
import { BaseSchema } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

export const VocabularyGroupSchema = BaseSchema.extend({
  name: z.string().max(255),
  vocabularyWords: z.array(z.string().uuid()).default([]),
  order: z.number(),
  expanded: z.boolean().optional(),
  visible: z.boolean().optional(),
  vocabulary: z.string().max(255)
});

export type VocabularyGroup = z.infer<typeof VocabularyGroupSchema>;

export const VocabularyGroupEntityQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: VocabularyGroupSchema,
});

export type VocabularyGroupEntityQueryResult = z.infer<typeof VocabularyGroupEntityQueryResultSchema>;
